import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 21.93 21.93"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M10.96 0c-.5 0-.91.41-.91.91v3.65c0 .5.41.91.91.91s.91-.41.91-.91V.91c0-.5-.41-.91-.91-.91M10.96 16.45c-.5 0-.91.41-.91.91v3.65c0 .5.41.91.91.91s.91-.41.91-.91v-3.65c0-.5-.41-.91-.91-.91M5.48 10.96c0-.5-.41-.91-.91-.91H.91c-.5 0-.91.41-.91.91s.41.91.91.91h3.65c.5 0 .91-.41.91-.91ZM21.01 10.05h-3.65c-.5 0-.91.41-.91.91s.41.91.91.91h3.65c.5 0 .91-.41.91-.91s-.41-.91-.91-.91M4.5 3.21c-.36-.36-.94-.36-1.29 0s-.36.94 0 1.29l2.58 2.58c.36.36.94.36 1.29 0s.36-.94 0-1.29zM16.13 14.84a.905.905 0 0 0-1.29 0c-.36.36-.36.94 0 1.29l2.58 2.58c.36.36.94.36 1.29 0 .36-.36.36-.94 0-1.29zM5.8 14.84l-2.58 2.58c-.36.36-.36.94 0 1.29.36.36.94.36 1.29 0l2.58-2.58c.36-.36.36-.94 0-1.29a.905.905 0 0 0-1.29 0M16.13 7.09l2.58-2.58c.36-.36.36-.94 0-1.29s-.94-.36-1.29 0L14.84 5.8c-.36.36-.36.94 0 1.29s.94.36 1.29 0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }